import { NgModule } from '@angular/core';
import { DfManageCardMultiselectableDirective } from './manage-card-selectable.directive';
import { AlertMessageComponent } from './alert.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    AlertMessageComponent,
    DfManageCardMultiselectableDirective
  ],
  imports: [
    SharedModule
  ],
  exports: [
    AlertMessageComponent
  ]
})
export class AlertModule {
}
